import React, { useMemo } from 'react';
import { formatCurrency } from '../../../shared/constants';

const CategoryBreakdownClient = ({ expenses }) => {
	const categoryTotals = useMemo(() => {
		const totals = {};
		expenses.forEach((expense) => {
			if (!totals[expense.category]) {
				totals[expense.category] = 0;
			}
			// Ensure amount is numeric (defensive programming for type safety)
			const amount = typeof expense.amount === 'string' ? parseFloat(expense.amount) : expense.amount;
			totals[expense.category] += amount || 0;
		});
		return Object.entries(totals)
			.map(([category, amount]) => ({ category, amount }))
			.sort((a, b) => b.amount - a.amount); // Sort by amount descending
	}, [expenses]);

	const total = useMemo(() => {
		return expenses.reduce((sum, expense) => {
			// Ensure amount is numeric (defensive programming for type safety)
			const amount = typeof expense.amount === 'string' ? parseFloat(expense.amount) : expense.amount;
			return sum + (amount || 0);
		}, 0);
	}, [expenses]);

	if (expenses.length === 0) {
		return (
			<div className='bg-white rounded-lg border border-gray-200 p-6'>
				<h3 className='text-lg font-glacial font-bold text-clientBlack mb-4'>
					Category Breakdown
				</h3>
				<p className='text-sm font-montserrat text-gray-500'>
					No expenses for this period
				</p>
			</div>
		);
	}

	return (
		<div className='bg-white rounded-lg border border-gray-200 p-6'>
			<h3 className='text-lg font-glacial font-bold text-clientBlack mb-4'>
				Category Breakdown
			</h3>

			{/* Category List */}
			<div className='space-y-4 mb-6'>
				{categoryTotals.map(({ category, amount }) => (
					<div key={category} className='space-y-2'>
						<div className='flex justify-between items-center'>
							<span className='text-sm font-montserrat text-gray-700'>
								{category}
							</span>
							<span className='text-sm font-montserrat-medium text-clientBlack'>
								{formatCurrency(amount)}
							</span>
						</div>
						{/* Progress Bar */}
						<div className='w-full bg-gray-200 rounded-full h-2'>
							<div
								className='bg-primary h-2 rounded-full transition-all duration-300'
								style={{
									width: `${(amount / total) * 100}%`,
								}}
							/>
						</div>
					</div>
				))}
			</div>

			{/* Total */}
			<div className='pt-4 border-t border-gray-200'>
				<div className='flex justify-between items-center'>
					<span className='text-base font-montserrat-medium text-clientBlack'>
						Total
					</span>
					<span className='text-2xl font-glacial font-bold text-primary'>
						{formatCurrency(total)}
					</span>
				</div>
			</div>
		</div>
	);
};

export default CategoryBreakdownClient;
